import { from, of } from 'rxjs';
import { DownloadPrintableCheckRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/common/printable_check/printable_check_requests';
import { assertNonNullable } from '@banking/ui/utils/assert';
import { Action, ActionCreator } from './index';
import { downloadPdf, printPdf } from '@banking/ui/utils/pdf';
// Work
// =============================================================================

function downloadPrintableCheck(context, state) {
  if (state.printableCheckId) {
    return context.downloadPrintableCheck(DownloadPrintableCheckRequest.create({
      printableCheckId: state.printableCheckId
    })).then(ActionCreator.receivedDownloadPrintableCheck).catch(error => {
      context.sentry.captureException(error);
      return null;
    });
  } else {
    context.sentry.captureException('DownloadPrintableCheck: no printable check id');
    return null;
  }
}
const handleDownloadPrintableCheck = context => (state, printableCheckId) => {
  if (state.checkPdf && state.checkPdfFilename && printableCheckId === state.printableCheckId) {
    downloadPdf(state.checkPdf, state.checkPdfFilename);
    return [{
      ...state,
      isLoadingDownloadCheck: false
    }, null];
  }
  const result = downloadPrintableCheck(context, state);
  if (result) {
    const work = () => from(result);
    return [{
      ...state,
      printableCheckId
    }, work];
  } else {
    return [state, null];
  }
};
function handleReceivedDownloadPrintableCheck(state, action) {
  assertNonNullable(action.response);
  const {
    checkPdf,
    pdfFilename
  } = action.response;
  if (state.isLoadingDownloadCheck) {
    downloadPdf(checkPdf, pdfFilename);
  } else if (state.isLoadingPrintCheck) {
    printPdf(checkPdf);
  }
  return [{
    ...state,
    checkPdf,
    checkPdfFilename: pdfFilename,
    isLoadingDownloadCheck: false,
    isLoadingPrintCheck: false
  }, null];
}
const handleUserClickPrintCheck = context => (state, printableCheckId) => {
  const checkIssuedLogEvent = state.checkIssuedConfiguration?.logEvents?.clickPrintLogEvent;
  if (checkIssuedLogEvent) {
    context.logEvents.track(checkIssuedLogEvent);
  }
  if (state.checkPdf && printableCheckId === state.printableCheckId) {
    printPdf(state.checkPdf);
    return [{
      ...state,
      isLoadingPrintCheck: false
    }, null];
  }
  const work = () => of(ActionCreator.requestDownloadPrintableCheck(printableCheckId));
  return [{
    ...state,
    printableCheckId
  }, work];
};

// Update
// =============================================================================

export const update = context => (state, action) => {
  switch (action.type) {
    case Action.Type.ReceivedDownloadPrintableCheck:
      return handleReceivedDownloadPrintableCheck(state, action);
    case Action.Type.RequestDownloadPrintableCheck:
      return handleDownloadPrintableCheck(context)(state, action.printableCheckId);
    case Action.Type.UserClickDismissPrintableCheckBlade:
      return [{
        ...state,
        checkPdf: undefined,
        checkPdfFilename: undefined,
        isLoadingDownloadCheck: false,
        isLoadingPrintCheck: false
      }, null];
    case Action.Type.UserClickDownloadCheck:
      {
        const checkIssuedLogEvent = state.checkIssuedConfiguration?.logEvents?.clickDownloadLogEvent;
        if (checkIssuedLogEvent) {
          context.logEvents.track(checkIssuedLogEvent);
        }
        return [{
          ...state,
          isLoadingDownloadCheck: true,
          printableCheckId: action.printableCheckId
        }, () => of(ActionCreator.requestDownloadPrintableCheck(action.printableCheckId))];
      }
    case Action.Type.UserClickPrintCheck:
      return handleUserClickPrintCheck(context)({
        ...state,
        isLoadingPrintCheck: true
      }, action.printableCheckId);
  }
};